import { useState } from 'react';
import { EmailPasswordProps, SignInResponseModel } from './UserModels';
import { api, baseUrl } from '#shared/ApiClient';
import { Button } from '#shared/components/Button';

function EmailPassword({
  onRequestMultifactor,
  setConfirmationMessage,
  onRequestSSO,
  lastLoginEmailAddress,
  initialErrorMessage,
}: EmailPasswordProps) {
  const [emailAddress, setEmailAddress] = useState(lastLoginEmailAddress || '');
  const [password, setPassword] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(initialErrorMessage ?? '');

  const handleSubmit = async (event: { preventDefault: () => void }) => {
    event.preventDefault();
    setSubmitted(true);

    const urlParams = new URLSearchParams(globalThis.location.search);
    const redirectUrl = urlParams.get('ReturnUrl');
    const signInRequestModel = {
      emailAddress,
      password,
      ReturnUrl: redirectUrl,
    };

    const result: SignInResponseModel = await api.post('SignIn', signInRequestModel);

    if (result.Success && result.RedirectUrl) {
      MixpanelTracking?.trackPageLoad(result.RedirectUrl);
      setErrorMessage('');
      globalThis.location.href = result.RedirectUrl;
    }

    if (result.MultifactorSignInViewModel) {
      onRequestMultifactor(result.MultifactorSignInViewModel);
    }

    if (result.ErrorMessage) {
      setErrorMessage(result.ErrorMessage);
      setSubmitted(false);
    }

    if (result.ConfirmationMessage) {
      setConfirmationMessage(result.ConfirmationMessage);
    }
  };

  return (
    <form method="post" onSubmit={handleSubmit}>
      <input
        className="form-control"
        id="EmailAddress"
        name="EmailAddress"
        required
        placeholder="Email address"
        type="text"
        value={emailAddress}
        onChange={(e) => {
          setEmailAddress(e.target.value);
          setErrorMessage('');
        }}
      />
      <input
        className="form-control"
        id="Password"
        name="Password"
        required
        placeholder="Password"
        type="password"
        value={password}
        onChange={(e) => {
          setPassword(e.target.value);
          setErrorMessage('');
        }}
      />
      {errorMessage && <div className="error-message">{errorMessage}</div>}
      <Button type="submit" className="btn-glow primary signup" disabled={submitted}>
        Sign in
      </Button>
      <div className="or-separator">OR</div>
      <Button
        type="button"
        className="btn-glow secondary signup corporate-sso"
        disabled={submitted}
        onClick={onRequestSSO}
      >
        Sign in with Corporate SSO
      </Button>
      <div className="forgot-block">
        <a className="forgot" href={`${baseUrl}ForgotPassword`}>
          Forgot your password?
        </a>
      </div>
    </form>
  );
}

export default EmailPassword;
